import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromBlind from './blinds.reducer';

export interface BlindState {
  blinds: fromBlind.BlindState;
}

export const reducers: ActionReducerMap<BlindState> = {
  blinds: fromBlind.blindsReducer,
};

export const selectBlindState = createFeatureSelector<fromBlind.BlindState>(fromBlind.inRoomBlindsFeatureKey);

export const selectBlindEntities = createSelector(selectBlindState, fromBlind.selectBlindEntities);

export const selectCurrentBlinds = createSelector(
  selectBlindEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (entities, location: string, room: string) => {
    return entities[fromBlind.selectBlindId(location, room)];
  }
);
